// extracted by mini-css-extract-plugin
export default {"overlay":"Vw-z","bodyOpen":"Ww-z","content":"Xw-z","header":"Yw-z","close":"Zw-z","closeNoHeading":"_w-z"};